import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const PlusIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M8.82357 3.80952H6.19048V1.17643C6.19048 0.529524 5.64714 0 5 0C4.35286 0 3.80952 0.529524 3.80952 1.17643V3.80952H1.17643C0.529524 3.80952 0 4.35286 0 5C0 5.64714 0.529524 6.19048 1.17643 6.19048H3.80952V8.82357C3.80952 9.47048 4.35286 10 5 10C5.64714 10 6.19048 9.47048 6.19048 8.82357V6.19048H8.82357C9.47048 6.19048 10 5.64714 10 5C10 4.35286 9.47048 3.80952 8.82357 3.80952Z"
    />
  </svg>
);

PlusIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

PlusIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(10, 10),
};

export default PlusIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/plus.js